import { QueryCache, QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

// Defaults follow waypoint_wars (ui/common/api/queryClient.ts). A factory,
// not a singleton, so a test can build an isolated client.
export function createQueryClient(): QueryClient {
  const client: QueryClient = new QueryClient({
    // A 401 means the cached data belongs to a session that is gone; clear it
    // so the next render refetches as whoever is signed in now.
    queryCache: new QueryCache({
      onError: (error) => {
        if (error instanceof ApiError && error.status === 401) client.clear();
      },
    }),
    defaultOptions: {
      queries: {
        // Library, play time and players change on human timescales: long
        // enough that moving between pages is instant, short enough that a
        // game someone just added shows up.
        staleTime: 30_000,
        // Going back to a page shows what it had while it refetches.
        gcTime: 5 * 60_000,
        // The player is left open for hours; a refetch per focus is wasted
        // requests. A stale query already refetches when its page mounts.
        refetchOnWindowFocus: false,
        // One retry for a network or Lambda hiccup. A 4xx (signed out, not in
        // the group) will not improve, and apiRequest has already refreshed
        // the token once.
        retry: (failures, error) =>
          failures < 1 && !(error instanceof ApiError && error.status !== undefined && error.status < 500),
      },
    },
  });
  return client;
}
